import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import HeroSlide from './HeroSlide';

const heroSlidesData = [
  {
    backgroundImage: "https://images.pexels.com/photos/6192453/pexels-photo-6192453.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    title: "Where Creatives <br /> Meet, Grow, and <br /> Create Together"
  },
  {
    backgroundImage: "https://images.pexels.com/photos/31138026/pexels-photo-31138026.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    title: "Africa’s <br /> Creative <br /> Pulse"
  },
  {
    backgroundImage: "https://images.pexels.com/photos/936030/pexels-photo-936030.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    title: "Create Boldly. <br /> Commune <br /> Bravely."
  }
];

const Slider = () => {
  const sliderOptions = {
    slidesPerView: 1,
    loop: true,
    effect: 'fade',
    pagination: {
      el: '#main-slider-pagination',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: '#main-slider__swiper-button-next',
      prevEl: '#main-slider__swiper-button-prev',
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  };

  return (
    <section className="main-slider main-slider-two" id="home" style={{ height: '100vh', padding: 0, margin: 0 }}>
      <Swiper {...sliderOptions} modules={[EffectFade, Navigation, Pagination, Autoplay]} className="swiper-container thm-swiper__slider" style={{ height: '100vh' }}>
        {heroSlidesData.map((slide, index) => (
          <SwiperSlide key={index}>
            <HeroSlide
              backgroundImage={slide.backgroundImage}
              title={slide.title}
            />
          </SwiperSlide>
        ))}
        <div className="swiper-pagination" id="main-slider-pagination"></div>
        <div className="main-slider__nav">
          <div className="swiper-button-prev" id="main-slider__swiper-button-next">
            <i className="fa fa-angle-left"></i>
          </div>
          <div className="swiper-button-next" id="main-slider__swiper-button-prev">
            <i className="fa fa-angle-right"></i>
          </div>
        </div>
      </Swiper>
    </section>
  );
};

export default Slider;
